import get from './methodGet';
import patch from './methodPatch';
import post from './methodPost';
import put from './methodPut';

export default { ...get, ...patch, ...post, ...put };
